import styled from 'styled-components';

export const StyledBookmarksSidebar = styled.div`
  background-color: ${({ theme }) => theme.themeColors.sidebars.background};
  display: flex;
  flex-direction: column;
  height: calc(100% - 145px);
  left: ${props => (props.isOpened ? '0' : `-${props.sidebarWidth}`)};
  overflow-y: auto;
  position: fixed;
  top: 60px;
  transition: left 0.5s ease;
  width: ${props => props.sidebarWidth};
  z-index: 3000;
`;

export const StyledBookmarksWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledBookmarksHeader = styled.div`
  align-items: center;
  background: ${({ theme }) =>
    theme.themeColors.sidebars.bookmarks.headerBackground};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
  min-height: 40px;
`;
